<form class="mc-spring-board">
  <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
    <mat-tab label="Teams">
      <div class="mc-spring-board">
        <div class="mc-spring-board-header">
          <button #popupTriggerTeams *ngIf="(canEdit$ | async)" type="button" color="primary" [disabled]="savingState.loading$ | async" mat-raised-button [mcPopupTriggerAutoClose]="false" [mcPopupTriggerFor]="addProjectTeamsPopup" [mcPopupWidth]="506">
            <div class="mc-d-flex mc-align-items-center">
              <ng-container *ngIf="savingState.loading$ | async; else addProjectTeams">Adding Project Teams</ng-container>
              <ng-template #addProjectTeams>Add Project Teams</ng-template>
              &nbsp;
              <mc-dropdown-arrow></mc-dropdown-arrow>
            </div>
          </button>
          <mat-form-field mcColor="secondary" class="mc-form-field">
            <mat-label>Filter Project Teams</mat-label>
            <div class="mc-project-access-form-access-project-entity">
              <input #filterProjectTeams matInput placeholder="Name" name="filterProjectTeam" (keyup)="onFilterProjectTeamsKeyUp($event)">
            </div>
          </mat-form-field>
          <mc-filter-bar display="list" [filterable]="projectTeamsList"></mc-filter-bar>
        </div>
        <div class="mc-spring-board-form-body">
          <mc-project-teams-list #projectTeamsList [projectId]="project?.Id" [canEdit]="(canEdit$ | async)" (saved)="onSaved()"></mc-project-teams-list>
        </div>
      </div>
      <mc-popup #addProjectTeamsPopup (closed)="onProjectTeamsPopupClosed()">
        <div class="mc-spring-board">
          <div class="mc-spring-board-form-body">
            <mat-form-field mcColor="secondary" class="mc-form-field mc-form-field-compact">
              <mat-label>Add Project Teams</mat-label>
              <mc-autocomplete-input #projectTeamsAutoComplete [multiple]="true" [closePopupOnSelection]="true" [triggerPopupOnFocus]="false" placeholder="Type to find teams">
                <mc-teams-select-list mcAutocompleteList [licenseId]="project?.LicenseId"></mc-teams-select-list>
                <ng-template mcAutocompleteItem let-teamId="item">
                  <mc-team-avatar compact [disabled]="true" [team]="teamId | mcTeamAsync | async" size="small" [truncate]="true"></mc-team-avatar>
                </ng-template>
              </mc-autocomplete-input>
            </mat-form-field>
          </div>
          <div class="mc-spring-board-form-footer">
            <div class="mc-form-buttons">
              <button type="button" mat-stroked-button color="warn" (click)="onCancelProjectTeamsClicked()">Cancel</button>
              <button type="button" mat-raised-button color="primary" (click)="onAddProjectTeamsClicked()">Add Teams to Project</button>
            </div>
          </div>
        </div>
      </mc-popup>
    </mat-tab>

    <mat-tab label="Users">
      <div class="mc-spring-board">
        <div class="mc-spring-board-header">
          <button #popupTriggerUsers *ngIf="(canEdit$ | async)" type="button" color="primary" class="dropdown-button" [disabled]="savingState.loading$ | async" mat-raised-button [mcPopupTriggerAutoClose]="false" [mcPopupTriggerFor]="addProjectLicenseUsersPopup" [mcPopupWidth]="506">
            <div class="mc-d-flex mc-align-items-center">
              <ng-container *ngIf="savingState.loading$ | async; else addProjectLicenseUsers">Adding Project Users</ng-container>
              <ng-template #addProjectLicenseUsers>Add Project Users</ng-template>
              &nbsp;
              <span class="mc-fill-remaining-flex-space"></span>
              <mc-dropdown-arrow></mc-dropdown-arrow>
            </div>
          </button>
          <mat-form-field mcColor="secondary" class="mc-form-field">
            <mat-label>Filter Project Users</mat-label>
            <div class="mc-project-access-form-access-project-entity">
              <input #filterProjectLicenseUsers matInput placeholder="Name, Email" name="filterProjectLicenseUser" (keyup)="onFilterProjectLicenseUsersKeyUp($event)">
            </div>
          </mat-form-field>
          <mc-filter-bar display="list" [filterable]="projectLicenseUsersList"></mc-filter-bar>
        </div>
        <div class="mc-spring-board-form-body">
          <mc-project-license-users-list #projectLicenseUsersList [projectId]="project?.Id" [canEdit]="(canEdit$ | async)" (saved)="onSaved()"></mc-project-license-users-list>
        </div>
      </div>
      <mc-popup #addProjectLicenseUsersPopup (closed)="onProjectLicenseUsersPopupClosed()">
        <div class="mc-spring-board">
          <div class="mc-spring-board-form-body">
            <mat-form-field mcColor="secondary" class="mc-form-field mc-form-field-compact">
              <mat-label>Add Project Users</mat-label>
              <mc-autocomplete-input #projectLicenseUsersAutoComplete [multiple]="true" [closePopupOnSelection]="true" [triggerPopupOnFocus]="false" placeholder="Type to find users">
                <mc-license-users-select-list mcAutocompleteList [licenseId]="project?.LicenseId" [seatTypes]="[LicenseUserSeatType.Author]"></mc-license-users-select-list>
                <ng-template mcAutocompleteItem let-licenseUserId="item">
                  <mc-license-user-avatar compact [disabled]="true" [licenseUser]="licenseUserId | mcLicenseUserAsync | async" size="small" [truncate]="true"></mc-license-user-avatar>
                </ng-template>
              </mc-autocomplete-input>
            </mat-form-field>
          </div>
          <div class="mc-spring-board-form-footer">
            <div class="mc-form-buttons">
              <button type="button" mat-stroked-button color="warn" (click)="onCancelProjectLicenseUsersClicked()">Cancel</button>
              <button type="button" mat-raised-button color="primary" (click)="onAddProjectLicenseUsersClicked()">Add Users to Project</button>
            </div>
          </div>
        </div>
      </mc-popup>
    </mat-tab>
  </mat-tab-group>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
  </div>
  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>